module.exports = __webpack_public_path__ + "portal-static/img/courseintro_decor_01.dabc5761.png";